import { State, ExternalPublishedCountItem } from '../../../types/state';

export const externalPublishedCountSelector = (state: State): ExternalPublishedCountItem[] =>
    state.pagedListings.externalPublishedCounts;